var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _positions;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import classNames from 'classnames';
import uniqueId from 'lodash/uniqueId';
import TetherComponent from 'react-tether';

import IconClose from '../../icons/general/IconClose';
import PlainButton from '../../components/plain-button';

import './Tooltip.scss';

var BOTTOM_CENTER = 'bottom-center';
var BOTTOM_LEFT = 'bottom-left';
var BOTTOM_RIGHT = 'bottom-right';
var MIDDLE_LEFT = 'middle-left';
var MIDDLE_RIGHT = 'middle-right';
var TOP_CENTER = 'top-center';
var TOP_LEFT = 'top-left';
var TOP_RIGHT = 'top-right';

var CALLOUT_THEME = 'callout';
var DEFAULT_THEME = 'default';
var ERROR_THEME = 'error';

var positions = (_positions = {}, _defineProperty(_positions, BOTTOM_CENTER, {
    attachment: 'top center',
    targetAttachment: 'bottom center'
}), _defineProperty(_positions, BOTTOM_LEFT, {
    attachment: 'top right',
    targetAttachment: 'bottom right'
}), _defineProperty(_positions, BOTTOM_RIGHT, {
    attachment: 'top left',
    targetAttachment: 'bottom left'
}), _defineProperty(_positions, MIDDLE_LEFT, {
    attachment: 'middle right',
    targetAttachment: 'middle left'
}), _defineProperty(_positions, MIDDLE_RIGHT, {
    attachment: 'middle left',
    targetAttachment: 'middle right'
}), _defineProperty(_positions, TOP_CENTER, {
    attachment: 'bottom center',
    targetAttachment: 'top center'
}), _defineProperty(_positions, TOP_LEFT, {
    attachment: 'bottom right',
    targetAttachment: 'top right'
}), _defineProperty(_positions, TOP_RIGHT, {
    attachment: 'bottom left',
    targetAttachment: 'top left'
}), _positions);

var bpfrpt_proptype_Position = PropTypes.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'middle-left', 'middle-right', 'top-center', 'top-left', 'top-right']);

var Tooltip = function (_React$Component) {
    _inherits(Tooltip, _React$Component);

    function Tooltip(props) {
        _classCallCheck(this, Tooltip);

        var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

        _this.tooltipID = uniqueId('tooltip');

        _this.closeTooltip = function () {
            _this.setState({ wasClosedByUser: true });
        };

        _this.fireChildEvent = function (type, event) {
            var handler = _this.props.children.props[type];
            if (handler) {
                handler(event);
            }
        };

        _this.handleMouseEnter = function (event) {
            _this.setState({ isShown: true });
            _this.fireChildEvent('onMouseEnter', event);
        };

        _this.handleMouseLeave = function (event) {
            _this.setState({ isShown: false });
            _this.fireChildEvent('onMouseLeave', event);
        };

        _this.handleFocus = function (event) {
            _this.setState({ isShown: true });
            _this.fireChildEvent('onFocus', event);
        };

        _this.handleBlur = function (event) {
            _this.setState({ isShown: false });
            _this.fireChildEvent('onBlur', event);
        };

        _this.handleKeyDown = function (event) {
            if (event.key === 'Escape') {
                _this.setState({ isShown: false });
            }
            _this.fireChildEvent('onKeyDown', event);
        };

        _this.state = { isShown: !!props.isShown, wasClosedByUser: false };
        return _this;
    }

    _createClass(Tooltip, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                bodyElement = _props.bodyElement,
                children = _props.children,
                className = _props.className,
                constrainToScrollParent = _props.constrainToScrollParent,
                constrainToWindow = _props.constrainToWindow,
                isShownProp = _props.isShown,
                position = _props.position,
                showCloseButton = _props.showCloseButton,
                text = _props.text,
                theme = _props.theme;

            var isControlled = typeof isShownProp !== 'undefined';
            var isShown = isControlled ? isShownProp : this.state.isShown;
            var showTooltip = isShown && !this.state.wasClosedByUser;
            var withCloseButton = showCloseButton && isControlled;
            var tetherPosition = positions[position];
            var constraints = [];
            var componentProps = {};

            if (constrainToScrollParent) {
                constraints.push({
                    to: 'scrollParent',
                    attachment: 'together'
                });
            }
            if (constrainToWindow) {
                constraints.push({
                    to: 'window',
                    attachment: 'together'
                });
            }

            if (showTooltip) {
                componentProps['aria-describedby'] = this.tooltipID;
            }
            if (!isControlled) {
                componentProps.onBlur = this.handleBlur;
                componentProps.onFocus = this.handleFocus;
                componentProps.onKeyDown = this.handleKeyDown;
                componentProps.onMouseEnter = this.handleMouseEnter;
                componentProps.onMouseLeave = this.handleMouseLeave;
                componentProps.tabIndex = '0';
            }

            var bodyEl = bodyElement instanceof HTMLElement ? bodyElement : document.body;

            var classes = classNames('tooltip', className, {
                'is-callout': theme === CALLOUT_THEME,
                'is-error': theme === ERROR_THEME,
                'with-close-button': withCloseButton
            });
            return React.createElement(
                TetherComponent,
                {
                    attachment: tetherPosition.attachment,
                    bodyElement: bodyEl,
                    classPrefix: 'tooltip',
                    constraints: constraints,
                    enabled: showTooltip,
                    targetAttachment: tetherPosition.targetAttachment
                },
                React.cloneElement(React.Children.only(children), componentProps),
                showTooltip && React.createElement(
                    'div',
                    { className: classes, id: this.tooltipID, role: 'tooltip' },
                    text,
                    withCloseButton && React.createElement(
                        PlainButton,
                        {
                            className: 'tooltip-close-button',
                            onClick: this.closeTooltip
                        },
                        React.createElement(IconClose, null)
                    )
                )
            );
        }
    }]);

    return Tooltip;
}(React.Component);

Tooltip.defaultProps = {
    constrainToScrollParent: false,
    constrainToWindow: true,
    position: TOP_CENTER,
    theme: DEFAULT_THEME
};
Tooltip.propTypes = {
    bodyElement: function bodyElement() {
        return (typeof HTMLElement === 'function' ? PropTypes.instanceOf(HTMLElement) : PropTypes.any).apply(this, arguments);
    },

    /** A React element to put the tooltip on */
    children: PropTypes.node.isRequired,

    /** A CSS class for the tooltip */
    className: PropTypes.string,

    /** Whether to constrain the tooltip to the element's scroll parent. Defaults to `false` */
    constrainToScrollParent: PropTypes.bool.isRequired,

    /** Whether to constrain the tooltip to window. Defaults to `true` */
    constrainToWindow: PropTypes.bool.isRequired,

    /** Forces the tooltip to be shown or hidden (useful for errors) */
    isShown: PropTypes.bool,

    /** Where to position the tooltip relative to the wrapped component */
    position: PropTypes.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'middle-left', 'middle-right', 'top-center', 'top-left', 'top-right']).isRequired,

    /** Shows an X button to close the tooltip. Useful when tooltips are force shown with the isShown prop. */
    showCloseButton: PropTypes.bool,
    text: PropTypes.node.isRequired,

    /** Text to show in the tooltip */
    theme: PropTypes.oneOf(['callout', 'default', 'error']).isRequired
};


export default Tooltip;
import PropTypes from 'prop-types';
export { bpfrpt_proptype_Position };